import React from "react";

import { Badge, TColor } from "@amphore-dev/amphore-lib";
import { t } from "i18next";

import { parseDay } from "@/utils/UDates";

import { TInvoice } from "@/types";

const COLORS: Record<TInvoice["status"], TColor> = {
	draft: "neutral",
	finalized: "info",
	paid: "success",
};

/** Draft / issued / paid — and "overdue" in red for an issued invoice past its due date. */
export const InvoiceStatusBadge: React.FC<{
	invoice: Pick<TInvoice, "status" | "dueAt">;
	size?: "sm" | "md";
}> = ({ invoice, size = "sm" }) => {
	const overdue =
		invoice.status === "finalized" &&
		!!invoice.dueAt &&
		parseDay(invoice.dueAt) < new Date(new Date().toDateString());

	return (
		<Badge color={overdue ? "danger" : COLORS[invoice.status]} size={size}>
			{t(`invoices.status.${overdue ? "unpaid" : invoice.status}`)}
		</Badge>
	);
};
